// import { MARKETINGLOG_PRODUCTVIEW } from './lbMarketingLog'

const FETCH_DATA_START = 'FETCH_DATA_START'
const FETCH_DATA_END = 'FETCH_DATA_END'
const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR'

function genFetchDataAction (action) {
  return (context, payload) => {
    context.dispatch('categories/fetchAll', payload)
    context.commit(FETCH_DATA_START)
    action(context, payload)
      .then(() => context.commit(FETCH_DATA_END))
      .catch((error) => {
        context.commit(FETCH_DATA_ERROR, error)
        return Promise.reject(error)
      })
  }
}

const state = {
  initDataFetching: false,
  error: null
}

const actions = {
  MainHome: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('display/fetchMainAll')
    ])
  )),
  Search: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('productList/search', { to })
    ])
  )),
  Brand: genFetchDataAction(({ dispatch }, { to }) => (
    Promise.all([
      dispatch('brand/fetchAllBrand'),
      dispatch('productList/fetchListByBrand', { to })
    ])
  )),
  Event: genFetchDataAction(({ dispatch }, { to }) => (
    Promise.all([
      dispatch('event/fetchEventDetail', to.params.eventNo)
    ])
  )),
  ProductDetail: genFetchDataAction(({ dispatch }, { to, from }) => {
    dispatch('product/fetchProduct', { productNo: to.params.productId, preview: to.query.preview, isAce: true })
    dispatch('product/fetchProductOptions', to.params.productId)
    // dispatch('coupon/myCoupons')
    dispatch('coupon/fetchProductCoupons', to.params.productId)
    dispatch('cart/fetchCartCount')
    dispatch('profile/memberFetch')
    dispatch('lbProductDetail/getProductNutrient', to.params.productId)
    dispatch('lbProductDetail/getProductAverageScore', to.params.productId)
    dispatch('lbProductDetail/getExpertReviewPreviewList', to.params.productId)
    dispatch('lbProductDetail/getProductNutritionalStandardList', to.params.productId)
    // dispatch('lbMarketingLog/setMarketingLog', { mallProductNo: to.params.productId, dbTargetCode: MARKETINGLOG_PRODUCTVIEW })

    return Promise.all([
    ])
  }),
  ReviewPage: genFetchDataAction(({ dispatch }, { to, from }) => {
    dispatch('lbProductDetail/getProductExpertReviewList', {mallProductNo: to.query.productId, page: 1, order: 0})
    return Promise.all([
    ])
  }),
  ProductDetailReview: genFetchDataAction(({ dispatch }, { to, from }) => {
    dispatch('product/fetchProduct', { productNo: to.params.productId, preview: to.query.preview })
    dispatch('product/fetchProductOptions', to.params.productId)
    // dispatch('coupon/myCoupons')
    dispatch('coupon/fetchProductCoupons', to.params.productId)
    dispatch('common/fetchMalls')
    dispatch('productreview/fetchProductReviews', to.params.productId)
    return Promise.all([
    ])
  }),
  ProductDetailInquiry: genFetchDataAction(({ dispatch }, { to, from }) => {
    dispatch('product/fetchProduct', { productNo: to.params.productId, preview: to.query.preview })
    dispatch('product/fetchProductOptions', to.params.productId)
    // dispatch('coupon/myCoupons')
    dispatch('coupon/fetchProductCoupons', to.params.productId)
    dispatch('common/fetchMalls')
    dispatch('productinquiry/fetchProductInquiry', to.params.productId)
    dispatch('productinquiry/fetchMemberInquiry', to.params.productId)
    return Promise.all([
    ])
  }),
  ProductDetailMoreInfo: genFetchDataAction(({ dispatch }, { to, from }) => {
    dispatch('product/fetchProduct', { productNo: to.params.productId, preview: to.query.preview })
    dispatch('product/fetchProductOptions', to.params.productId)
    // dispatch('coupon/myCoupons')
    dispatch('coupon/fetchProductCoupons', to.params.productId)
    return Promise.all([
    ])
  }),
  Cart: genFetchDataAction(({ dispatch, commit }, { to, from }) => (
    Promise.all([
      dispatch('cart/fetchCart'),
      dispatch('cart/fetchCartCount'),
      commit('ordersheet/CHANGE_ACCUMULATION_AMT', 0),
      commit('ordersheet/INIT_COUPONREQUEST_FROMCART')
    ])
  )),
  MemberSetting: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('authentication/fetchShopAgreement')
    ])
  )),
  OrderList: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('myorder/getOrderList', { type: 'ORDER', to: {query: {type: 'ORDER', month: '', period: 'six_month'}} })
    ])
  )),
  CancelList: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('myorder/getOrderList', { type: 'CANCEL', to })
    ])
  )),
  BeforeOrder: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('ordersheet/getSheetNo', to)
    ])
  )),
  OrderSheet: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('ordersheet/fetchOrder', { orderSheetNo: to.params.orderSheetNo, isNeedCheckMaximumCoupon: true }),
      // dispatch('ordersheet/fetchOrderConpons', to.params.orderSheetNo),
      dispatch('shippingaddresses/recentAddresses')
      // dispatch('profile/memberFetch')
    ])
  )),
  MyMain: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
    ])
  )),
  MyReviewable: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('profilereview/fetchProductReviewable')
    ])
  )),
  MyReviews: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('profilereview/fetchProfileProductReviews')
    ])
  )),
  ValidCoupon: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('validCoupon/getValidCoupons'),
      dispatch('validCoupon/getNoValidCoupons')
      // dispatch('validCoupon/getNoValidCoupons')
    ])
  )),
  NoValidCoupon: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('validCoupon/getNoValidCoupons')
      // dispatch('validCoupon/getValidCoupons'),
      // dispatch('validCoupon/getNoValidCoupons')
    ])
  )),
  LikeProducts: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('likeProducts/fetchLikeProducts')
    ])
  )),
  Return: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('myorder/getClaimOrderOption', {
        claimParams: {
          claimType: 'RETURN',
          orderOptionNo: to.params.orderOptionNo
        }
      })
    ])
  )),
  Cancel: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('myorder/getClaimOrderOption', {
        claimParams: {
          claimType: 'CANCEL',
          orderOptionNo: to.params.orderOptionNo
        }
      })
    ])
  )),
  NoneMemberCancel: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('guestorder/getGuestClaim', {
        claimParams: {
          claimType: 'CANCEL',
          orderOptionNo: to.params.orderOptionNo
        }
      })
    ])
  )),
  NoneMemberReturn: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('guestorder/getGuestClaim', {
        claimParams: {
          claimType: 'RETURN',
          orderOptionNo: to.params.orderOptionNo
        }
      })
    ])
  )),
  CancelDetail: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('myorder/getClaimResult', {
        claimParams: {
          orderOptionNo: to.params.orderOptionNo
        }
      })
    ])
  )),
  ReturnDetail: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('myorder/getMultipleClaimResult', {
        claimParams: {
          claimNo: to.params.claimNo
        }
      })
    ])
  )),
  NoneMemberCancelDetail: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('guestorder/getGuestClaimResult', {
        claimParams: {
          orderOptionNo: to.params.orderOptionNo
        }
      })
    ])
  )),
  NoneMemberReturnDetail: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('guestorder/getGuestMultipleClaimResult', {
        claimParams: {
          claimNo: to.params.claimNo
        }
      })
    ])
  )),
  Boards: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('display/boardsArticlesCategorys'),
      dispatch('display/boardsCategorys')
    ])
  )),
  ShopList: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMallsPartners')
    ])
  )),
  BoardInquiry: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('profile/memberFetch')
    ])
  )),
  PaymentConfirm: genFetchDataAction(({ dispatch, commit }, { to, from }) => (
    Promise.all([ 
      // 구매확정 적립금 정보 필요여부 플래그 설정
      commit('myorder/SET_NEED_SAVE_REWARD_INFO'),
      dispatch('myorder/getOrder', to.query.orderNo)
    ])
  )),
  AddReview: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('myorder/getOrder', to.params.orderNo)
    ])
  )),
  EditReview: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('myorder/getOrder', to.params.orderNo),
      dispatch('profilereview/fetchProductReviewDetail', {
        editParams: {
          reviewNo: to.params.reviewNo,
          productNo: to.params.productNo
        }
      })
    ])
  )),
  OrderDetail: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('myorder/getOrderDetail', to.params.orderNo)
    ])
  )),
  NoneMemberDetail: genFetchDataAction(({ dispatch }, { to }) => (
    Promise.all([
      dispatch('guestorder/getGuestOrderDetail', to.params.orderNo)
    ])
  )),
  MyProductInquirys: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls'),
      dispatch('productinquiry/fetchProductInquiries')
    ])
  )),
  ProfileInquiries: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('profileinquiry/fetchInquiries')
    ])
  )),
  MbrModify: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('profile/memberFetch')
    ])
  )),
  FindConfirm: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls')
    ])
  )),
  PwSearch: genFetchDataAction(({ dispatch }, { to, from }) => (
    Promise.all([
      dispatch('common/fetchMalls')
    ])
  )),
  Accumulations: genFetchDataAction(({ dispatch, commit }, { to, from }) => (
    Promise.all([
      commit('profile/INIT_ACCUMULATION_PARAMS'),
      dispatch('profile/fetchAccumulations'),
      dispatch('profile/fetchAccumulationsSummary'),
      dispatch('profile/fetchAccumulationsSummary30')
    ])
  )),
  DieterStory: genFetchDataAction(({ dispatch }, { to, from }) => {
    dispatch('lbDieterStory/getCommunityPostDetail', to.params.postID)
    return Promise.all([
    ])
  }),
  DietmealBookmark: genFetchDataAction(({ dispatch }, { to, from }) => {
    return Promise.all([
      dispatch('lbDietmeal/getDietMealFavoriteList')
    ])
  }),
  DietmealFilter: genFetchDataAction(({ dispatch, commit }, { to, from }) => (
    Promise.all([
      commit('lbDietmeal/COPY_FILTER')
    ])
  )),
  Certification: genFetchDataAction(({ dispatch, commit }, { to, from }) => {
    return Promise.all([
      commit('lbCertification/INIT_CERTIFICATION_FORM'),
      dispatch('lbCertification/getCertificationForm', to.params.returnUrl)
    ])
  }),
  LBInvite: genFetchDataAction(({ dispatch, commit }, { to, from }) => {
    return Promise.all([
      commit('lbInvitation/INIT_FRIENDS_LIST'),
      dispatch('lbInvitation/getInvitationPageInfo')
    ])
  }),
  LBFilteredProductList: genFetchDataAction(({ dispatch, commit }, { to, from }) => {
    return Promise.all([
      dispatch('common/fetchMalls')
    ])
  })
}

const mutations = {
  [FETCH_DATA_START] (state) {
    state.initDataFetching = true
  },
  [FETCH_DATA_END] (state) {
    state.initDataFetching = false
  },
  [FETCH_DATA_ERROR] (state, payload) {
    state.initDataFetching = false
    state.error = payload
  }
}

export default {
  state,
  actions: Object.keys(actions).reduce((obj, rawActionName) => {
    obj[`beforeEnter${rawActionName}`] = actions[rawActionName]
    return obj
  }, {}),
  mutations
}
